import { readonly } from "vue";

export function useToggle(defaultValue: boolean) {
  const value = ref(defaultValue);

  const toggle = () => (value.value = !value.value);
  const isOpen = computed(() => value.value);
  const open = () => (value.value = true);
  const close = () => (value.value = false);

  return {
    value: readonly(value),
    toggle,
    isOpen,
    open,
    close,
  };
}
